import Link from "next/link";
import Image from "next/future/image";
import { getProductLink, downloadLink } from "@/lib/utils.js";
import { CartContext } from '@/lib/cart_context.js'
import { useContext } from "react";
import CartButton from '@/components/cart_button'
import {useState} from 'react'; 
import  ShareDownloadsModal from '@/components/share_downloads_modal.js';



export default function ProductTileV2({
  product, page
}) {
  const cart = useContext(CartContext);
  const cartActive = cart?.itemInCart
  const itemInCart = cartActive && cart.itemInCart(product.id);
  const productLink = getProductLink(product);
  const contain = { objectFit: "contain" };
  const [showDownload, setShowDownloads] = useState(false);

  let product_links_display = (productLink && page == 'new') || (product.primary_spec_sheet && product.primary_spec_sheet.url)
  return (
    <>
    <div className="lexcms-product-tile-v2">
      <div className="lexcms-product-tile-v2-area">
        <div className="lexcms-product-tile-v2-image-area">
          <Link href={productLink}>
            <a>
              { page == 'discontinued' && product.is_discontinued && <div className="lexcms-discontinued-pill">DISCONTINUED</div> }
              { page == 'new' && product.is_new && <div className="lexcms-new-pill">NEW</div> }
              { page == 'legacy' && product.is_legacy && <div className="lexcms-legacy-pill">LEGACY</div> }
                <Image
                  unoptimized
                  priority
                  src={product.image}
                  alt={""}
                  className="lexcms-product-tile-v2-image"
                  fill
                  style={contain}
                />
            </a>
          </Link>
        </div>
        <div className="lexcms-product-tile-v2-text-area">
          <div className="lexcms-product-tile-v2-text">
            <Link href={productLink}>
              <a>
                <h3 className="lexcms-dicontinued-product-tile-name">{product.name}</h3>
              </a>
            </Link>
            <div className="lexcms-product-tile-v2-subname-container">
              <Link href={productLink}>
                <a>
                  <p className="lexcms-product-tile-v2-subname">{product.sub_name}</p>
                </a>
              </Link>
            </div>
            <hr/>
            { product.tile_description && 
              <div className="lexcms-product-tile-v2-description-container">
                <Link href={productLink}>
                  <a>
                    <p className="lexcms-product-tile-v2-description">{product.tile_description}</p>
                  </a>
                </Link>
              </div>
            }
          </div>
          { product_links_display && 
            <div className="lexcms-product-tile-v2-product-links-container"> 
              { page == 'new' && productLink && 
                <a
                  href={productLink}
                  className="lexcms-regular-button lexcms-product-tile-v2-product-link-button"
                >
                  View Product Page
                </a>
              }
              { product.primary_spec_sheet && product.primary_spec_sheet.url && (
                <a
                  href={downloadLink(product.primary_spec_sheet)}
                  target="_blank"
                  className="lexcms-regular-button lexcms-product-tile-v2-product-link-button"
                >
                  Specification Sheet
                </a>
              )}
              { product.download_modal_on_product_tiles && (
                <a
                  onClick={() => setShowDownloads(true ) }
                  target="_blank"
                  className="lexcms-regular-button lexcms-product-tile-v2-product-link-button"
                >
                  Downloads
                </a>
              )}
              { page == 'new' && 
                <CartButton 
                  cartActive={cartActive}
                  itemInCart={itemInCart}
                  cart={cart}
                  product={product}
                  _classes={"lexcms-regular-button lexcms-product-tile-v2-product-link-button"}
                />
              }
            </div>
          }
        </div>
      </div>
      { page == 'discontinued' && product.is_discontinued &&
        <div className="lexcms-discontinued-date">
          <span className="lexcms-discontinued-date-text">Product Discontinued: </span>{ `${new Date(product.discontinued_date).toLocaleString('en-us',{month:'long', year:'numeric'})}` }
        </div>
      }
      { page == 'new' && product.is_new &&
        <div className="lexcms-launch-date">
          <span className="lexcms-launch-date-text">Product Launched: </span>{ `${new Date(product.launch_date).toLocaleString('en-us',{month:'long', year:'numeric'})}` }
        </div>
      }
    </div>
    {showDownload &&
        <ShareDownloadsModal product={product} 
                             loadsDownloadsAsync={true}
                             setShowShare={setShowDownloads} 
                             showShare={showDownload} type={'download'}/>
       }

    </>
  );
}
